import VConsole from 'vconsole';

const __DEBUG__ = !['stg', 'prod'].includes(import.meta.env.MODE as string);
if (__DEBUG__) {
  const vConsole = new VConsole();
  vConsole.setSwitchPosition(3, 60);
}
